<template>
    <nav class="pagination-controls" aria-label="Pagination Navigation">
        <b-button
            :to="prevPage"
            variant="outline-primary"
            class="navigation-btn prev-btn"
            :disabled="currentPage < 2"
            v-test:prevBtn
        >
            <app-icon name="arrow-left" />
            <span class="sr-only">Previous page</span>
        </b-button>
        <span class="text">
            page
            <span v-test:currentPage>{{ currentPage }}</span>
            of
            <span v-test:totalPages>{{ totalPages }}</span>
        </span>
        <b-button
            :to="nextPage"
            variant="outline-primary"
            class="navigation-btn next-btn"
            :disabled="currentPage === totalPages"
            v-test:nextBtn
        >
            <app-icon name="arrow-right" />
            <span class="sr-only">Next page</span>
        </b-button>
    </nav>
</template>

<script>
    export default {
        name: 'pagination-controls',

        props: {
            totalPages: {
                type: Number,
                default: 1,
            },

            currentPage: {
                type: Number,
                default: 1,
            },
        },

        computed: {
            /**
             * Link for prev page.
             *
             * @returns {object}
             */
            prevPage() {
                if (this.currentPage === 2) {
                    return {
                        query: {},
                    };
                }

                return {
                    query: {
                        page: this.currentPage - 1,
                    },
                };
            },

            /**
             * Link fo next page.
             *
             * @returns {object}
             */
            nextPage() {
                return {
                    query: {
                        page: this.currentPage + 1,
                    },
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .pagination-controls {
        display: flex;
        align-items: center;
    }

    .text {
        font-size: rem(20px);
        line-height: rem(24px);
        padding-left: 30px;
        padding-right: 30px;
    }

    .navigation-btn {
        min-width: unset;
        width: 40px;
        height: 40px;
    }
</style>
